import React from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, Button } from 'reactstrap';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';
import { getUser, userLogout } from '../store/actions/authActions'
import Signout from './auth/Signout'
import { FaInfoCircle } from "react-icons/fa";
import RecipientNav from "./RecipientNav";
import Player from "./player";



export default class NavMenu extends React.Component {
  constructor (props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
  }
  toggle () {
    this.setState({
      isOpen: !this.state.isOpen
    });
    }

    getAdmin() {

        let idToken = localStorage.getItem('idToken');
        let user = getUser(idToken);
        console.log(user);
        if (user && (user.username.includes("@musicmanager.com") || user.username.includes("@bach.dk") || user.username.includes("@anettejensen.dk"))) {
            return (<NavItem><NavLink tag={Link} activeClassName="active" to="/recipients" active={window.location.pathname.includes("/recipients")}>Recipients <RecipientNav/></NavLink></NavItem>)
        } else {
            return (<NavItem></NavItem>)
        }       
    }


 

    

    logout() {
        let idToken = localStorage.getItem('idToken');
        if (idToken) {
            return (<NavItem><Signout /></NavItem>)
        } else {
            return (<NavItem></NavItem>)
        }
       
    }

    getLinks() {
        let idToken = localStorage.getItem('idToken');
       
        if (idToken) {

            return(
                <ul className="navbar-nav flex-grow">
              
                                       
               

            </ul>)
        } else {
            return (
                <ul className="navbar-nav flex-grow">
                  

                </ul>)
        }
    }

 

    render() {

     
        return (
      
      <header>
                <Navbar fixed={"top"} className="navbar-expand-sm navbar-toggleable-sm border-bottom mb-3" light >
                    <Container className="nav-container">
                        <NavbarBrand tag={Link} className="brand w-nav-brand w--current navbar-brand" to={{ pathname: "https://www.kinoclub.com" }} target="_self" ><img src='/img/Kc_header.png' alt="Kino Club" /> </NavbarBrand>
                       
            <NavbarToggler onClick={this.toggle} className="mr-2" />
                    <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={this.state.isOpen} navbar>
                        {this.getLinks()}
            </Collapse>
          </Container>
        </Navbar>
                </header>             
          
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NavMenu.js